import React, { Component } from 'react';
import { MultiSelect, ComboBox, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import { moment } from 'moment';
import { api } from '../../helpers/api/api';

export default class Combo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
      url: props.url,
      selectedItems: [],
    };
    this.onChange = this.onChange.bind(this);
  }

  async componentDidMount() {
    if (this.props.url !== undefined && this.props.url !== '' && this.props.url !== null)
      this.retriveItems();
    else {
      this.setState({
        items: this.props.items,
        loading: false,
        selectedItems: this.props.initialSelectedItems,
      });
    }
  }

  retriveItems = async () => {
    this.setState({ loading: true });
    const retrivedItems = await this.getItems();
    this.setState({
      items: retrivedItems,
      loading: false,
      selectedItems: this.props.initialSelectedItems,
    });
  };

  getItems = async () => {
    let items = [];
    try {
      items = (await api.getAll(this.state.url)).data;
    } catch (error) {
        console.error(error);
      this.props.onError(error);
    }
    return items;
  };

  onChange = (selectedItem) => {
    const items = selectedItem ? selectedItem.selectedItems : null;
    this.setState({
      selectedItems: items,
    });
    this.props.onChange(items);
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : this.props.multiCombo ? (
      <MultiSelect.Filterable
        disabled={this.state.items < 1 || this.props.disabled}
        placeholder={
          this.state.selectedItems < 1 || this.state.selectedItems == null
            ? 'Choose one or more items'
            : this.state.selectedItems
                .map((elem) => (typeof elem === 'object' ? elem.name : elem))
                .join(', ')
        }
        label=""
        itemToString={(item) =>
          item && typeof item === 'object'
            ? item && item.name
            : typeof item === 'object'
            ? ''
            : item
        }
        items={this.state.items || []}
        light={false}
        onChange={this.onChange}
        type="default"
        initialSelectedItems={this.props.initialSelectedItems}
      />
    ) : (
      <ComboBox
        className={this.props.dropUp ? 'open-up-combo-box' : ''}
        id={this.props.id}
        disabled={this.props.disabled || this.state.items < 1}
        placeholder={this.props.placeholder}
        items={this.state.items || []}
        onChange={this.props.onChange}
        shouldFilterItem={({ item, inputValue }) => {
          if (typeof inputValue === 'string') {
            if (typeof item === 'object')
              return item.name?.toLowerCase().includes(inputValue?.toLowerCase());
            return item.toLowerCase().includes(inputValue?.toLowerCase());
          }
        }}
        itemToString={
          this.props.itemToString != null
            ? this.props.itemToString
            : (item) =>
                item && typeof item === 'object'
                  ? item && item.name
                  : typeof item === 'object'
                  ? ''
                  : item
        }
        selectedItem={this.props.initialSelectedItems}
        invalid={this.props.invalid}
      />
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.url != null && nextProps.url !== '' && nextProps.url !== this.props.url) {
      this.state.url = nextProps.url;
      this.retriveItems();
    }
    if (nextProps.items != null && nextProps.items !== this.props.items) {
      this.setState({ items: nextProps.items });
    }
  }
}

Combo.propTypes = {
  entity: PropTypes.string,
  url: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  initialSelectedItems: PropTypes.array,
  onError: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

Combo.defaultProps = {
  entity: null,
  disabled: true,
};
